import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Calendar,
  FileText,
  Layers,
  Building2,
  Newspaper,
  Sparkles,
} from 'lucide-react';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/command';
import { useAuth } from '@/contexts/AuthContext';

interface CmsCommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CmsCommandPalette: React.FC<CmsCommandPaletteProps> = ({ open, onOpenChange }) => {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  const runCommand = (path: string) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Пребарувај страници, акции..." />
      <CommandList>
        <CommandEmpty>Нема резултати.</CommandEmpty>
        <CommandGroup heading="Навигација">
          <CommandItem onSelect={() => runCommand('/cms')}>
            <LayoutDashboard className="mr-2 h-4 w-4" />
            <span>Преглед (Dashboard)</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand('/cms/events')}>
            <Calendar className="mr-2 h-4 w-4" />
            <span>Настани</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand('/cms/registrations')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Регистрации</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand('/cms/series')}>
            <Layers className="mr-2 h-4 w-4" />
            <span>Серии на трки</span>
          </CommandItem>
          {isAdmin() && (
            <CommandItem onSelect={() => runCommand('/cms/organizers')}>
              <Building2 className="mr-2 h-4 w-4" />
              <span>Организатори</span>
            </CommandItem>
          )}
          <CommandItem onSelect={() => runCommand('/cms/posts')}>
            <Newspaper className="mr-2 h-4 w-4" />
            <span>Постови</span>
          </CommandItem>
          {isAdmin() && (
            <CommandItem onSelect={() => runCommand('/cms/ai')}>
              <Sparkles className="mr-2 h-4 w-4" />
              <span>AI Dashboard</span>
            </CommandItem>
          )}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Брзи акции">
          <CommandItem onSelect={() => runCommand('/cms/events')}>
            <Calendar className="mr-2 h-4 w-4" />
            <span>Креирај нов настан</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand('/cms/posts')}>
            <Newspaper className="mr-2 h-4 w-4" />
            <span>Креирај нов пост</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand('/cms/registrations')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Најди регистрација</span>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};

export default CmsCommandPalette;
